"use client"
import React from 'react'
import ContentFeature from '../ContentFeature'
import clsx from 'clsx'
import { BlockType } from '@/libs/types'
import ImageCustom from '@/components/Image'

interface ContentFeatureOneProps {
    block: BlockType
    locale: string
}

const ContentFeatureOne: React.FC<ContentFeatureOneProps> = ({ block, locale }) => {

    const [indexPicture, setIndexPicture] = React.useState<number>(0)

    const [blockThumbs] = React.useState(block.blocks.map((item: any) => item).filter((item: any) => !!item.thumb && item.thumb !== ""))

    const handleChangePicture = (newIndex: number) => {
        if (blockThumbs?.length <= 1 || blockThumbs.length < newIndex || !blockThumbs[newIndex].thumb) return;
        return setIndexPicture(newIndex)
    }

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-5 col-12">
                    <div className="h-100 d-flex align-items-center">
                        <div className="w-100 mt-0 mb-auto">
                            <ContentFeature locale={locale} variant="h2" block={block} handleChangePicture={handleChangePicture} />
                        </div>
                    </div>
                </div>
                {(block.blocks && block.blocks.length !== 0 || block.thumb !== "") && (
                    <div className="col-md-5 col-12">
                        <div className="h-100 d-flex align-items-center">
                            <div className="w-100 feature__thumb mb-auto">
                                {blockThumbs && blockThumbs?.map((item: BlockType, index: number) => {
                                    return (
                                        <div key={index} className={clsx("feature__thumb__one", (indexPicture === index || blockThumbs?.length === 1) ? "active" : "")}>
                                            <ImageCustom
                                                key={index}
                                                src={item?.thumb}
                                                height={item?.metadata?.thumb?.height || 345}
                                                width={item?.metadata?.thumb?.width || 542}
                                                alt={item?.title}
                                                className="object-fit-contain" />
                                        </div>
                                    )
                                })}
                                {(blockThumbs?.length === 0 && block?.thumb !== "" && !!block.thumb) && (
                                    <div className={clsx("feature__thumb__one", "active")}>
                                        <ImageCustom
                                            src={block?.thumb}
                                            height={block?.metadata?.thumb?.height || 345}
                                            width={block?.metadata?.thumb?.width || 542}
                                            alt={block?.title} className="object-fit-contain" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    )
}

export default ContentFeatureOne